import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

   tokenExpiredEvent=new Subject<string>();
  constructor() { }
}
